import { Module } from 'vuex';

export interface ComentarioDatosState {
  idRegistro: string | null;
  claveRegistro: string | null;
  idRegistroEstatus: string | null;
}

export const defaultComentarioDatosState: ComentarioDatosState = {
  idRegistro: null,
  claveRegistro: null,
  idRegistroEstatus: null,
};

export const comentarioDatosStore: Module<ComentarioDatosState, any> = {
  state: { ...defaultComentarioDatosState },
  getters: {
    idRegistro: state => state.idRegistro,
    claveRegistro: state => state.claveRegistro,
    idRegistroEstatus: state => state.idRegistroEstatus,
  },
  mutations: {
    setDatosComentario(
      state,
      { idRegistro, claveRegistro, idRegistroEstatus }: { idRegistro: string; claveRegistro: string; idRegistroEstatus: string }
    ) {
      state.idRegistro = idRegistro;
      state.claveRegistro = claveRegistro;
      state.idRegistroEstatus = idRegistroEstatus;
    },
    clearDatosComentario(state) {
      state.idRegistro = null;
      state.claveRegistro = null;
      state.idRegistroEstatus = null;
    },
  },
};
